import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import isFunction from 'lodash/fp/isFunction';
import { motion } from 'framer-motion';
import { getOrCreatePortalRoot } from '../../utils/portalRoot';
const OFFSET_POSITION = -1000;
const DEFAULT_OFFSET_PX = 15;
const BottomSheet = (props) => {
    const { show = false, onClose, width, height, title, detach = false, detachOffset = DEFAULT_OFFSET_PX, hasBackdrop = false, showCloseButton = true, showMaximizeButton = false, onHeightChange = () => { }, bodyRef, bodyClassName, className, children, onBackdropClick = () => { } } = props, remainingProps = __rest(props, ["show", "onClose", "width", "height", "title", "detach", "detachOffset", "hasBackdrop", "showCloseButton", "showMaximizeButton", "onHeightChange", "bodyRef", "bodyClassName", "className", "children", "onBackdropClick"]);
    const [isShown, setIsShown] = useState(show);
    const [isMaxHeight, setIsMaxHeight] = useState(false);
    useEffect(() => setIsShown(show), [show]);
    const modalRoot = getOrCreatePortalRoot();
    const handleToggle = () => {
        const newValue = !isShown;
        if (isFunction(onClose)) {
            onClose(newValue);
        }
        else {
            setIsShown(newValue);
        }
    };
    const handleBackdropClick = () => {
        onBackdropClick();
        handleToggle();
    };
    const handleMaximize = () => {
        const newValue = !isMaxHeight;
        setIsMaxHeight(newValue);
        onHeightChange();
    };
    const sheetClasses = classNames('bottom-sheet', 'position-fixed left-0', !height && !isMaxHeight && 'height-auto', 'bg-white', 'shadow-hard', detach ? 'rounded' : 'rounded-top-left rounded-top-right', className && className);
    const sheetBodyClasses = classNames('bottom-sheet-body', 'height-100pct', bodyClassName && bodyClassName);
    const sheetHeight = isMaxHeight ? window.innerHeight : height;
    // Note: we always have to kep the body element in the DOM as there might be a ref assigned to it.
    // Unmounting it will lead to losing the reference and breaking the functionality that is implemented on that ref.
    // That is the reason why there is no "AnimatePresence" with an "exit" animation here.
    // Instead, we change the "animate" values.
    return createPortal(_jsxs(_Fragment, { children: [_jsxs(motion.div, Object.assign({}, remainingProps, { className: sheetClasses, style: {
                    width,
                    maxWidth: detach ? `calc(100% - ${DEFAULT_OFFSET_PX * 2}px)` : '100%',
                    margin: detach ? `${DEFAULT_OFFSET_PX}px` : 0,
                }, initial: { opacity: 0 }, animate: {
                    opacity: isShown ? 1 : 0,
                    y: 0,
                    bottom: isShown ? 0 : OFFSET_POSITION,
                    height: isShown ? sheetHeight : 0,
                } }, { children: [_jsxs("div", Object.assign({ className: 'bottom-sheet-header' }, { children: [title && (_jsx("div", Object.assign({ className: 'bottom-sheet-title display-flex justify-content-between padding-15 ' +
                                    'border border-top-none border-left-none border-right-none border-color-lighter' }, { children: _jsx("div", Object.assign({ className: 'text-size-18' }, { children: title })) }))), showCloseButton && (_jsx("div", Object.assign({ className: 'bottom-sheet-close position-absolute top-10 right-10' }, { children: _jsx("button", Object.assign({ type: 'button', className: 'btn btn-muted btn-sm btn-icon-only', onClick: handleToggle }, { children: _jsx("span", { className: 'rioglyph rioglyph-remove' }) })) }))), showMaximizeButton && (_jsx("div", Object.assign({ className: 'bottom-sheet-maximize height-30 ' +
                                    'position-absolute top-5 left-50pct translate-x-50 cursor-pointer', onClick: handleMaximize }, { children: _jsx("div", { className: 'height-5 width-40 rounded bg-lighter' }) })))] })), _jsx("div", Object.assign({ className: sheetBodyClasses, ref: bodyRef }, { children: isShown && children }))] })), hasBackdrop && isShown && _jsx("div", { className: 'bottom-sheet-backdrop', onClick: handleBackdropClick })] }), modalRoot);
};
export default BottomSheet;
